import { Spin } from 'ant-design-vue'
import { createVNode, render } from 'vue'

const loadingDirective = {
  mounted(el, binding) {
    const loading = binding.value
    if (loading) {
      const spinVNode = createVNode(Spin, {
        spinning: true,
        size: 'large',
      })
      const div = document.createElement('div')
      div.style.cssText = `
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(255, 255, 255, 0.8);
        z-index: 1000;
      `
      render(spinVNode, div)
      el.style.position = 'relative'
      el.appendChild(div)
      el._loadingElement = div
    }
  },
  updated(el, binding) {
    const loading = binding.value
    if (loading) {
      if (!el._loadingElement) {
        const spinVNode = createVNode(Spin, {
          spinning: true,
          size: 'large',
        })
        const div = document.createElement('div')
        div.style.cssText = `
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(255, 255, 255, 0.8);
          z-index: 1000;
        `
        render(spinVNode, div)
        el.style.position = 'relative'
        el.appendChild(div)
        el._loadingElement = div
      }
    } else {
      if (el._loadingElement) {
        el.removeChild(el._loadingElement)
        el._loadingElement = null
      }
    }
  },
  unmounted(el) {
    if (el._loadingElement) {
      el.removeChild(el._loadingElement)
      el._loadingElement = null
    }
  },
}

const install = function (app) {
  app.directive('loading', loadingDirective)
}

export default install










